import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { LoadingSpinner } from '../../../shared/ui';
import {
  AdminBlogShell,
  AdminPageHeader,
  AdminReviewEditorFields,
  appendYowanContentPreviewQuery,
  usePreservedDomainSearch,
} from './AdminBlogListPage';
import { createYowanAdminReview } from '../app/yowanContentClient';
const { yowanPageContent } = require('./pageContent');

const reviewUrlValidationRules = (content) => ({
  pattern: {
    value: /^https:\/\/.+/i,
    message: content.form.errors.invalidUrl || 'URLは https:// から入力してください。',
  },
});

const AdminReviewsCreatePage = () => {
  const content = yowanPageContent['/admin/content/reviews/new'];
  const navigate = useNavigate();
  const preservedDomainSearch = usePreservedDomainSearch();
  const [submitMessage, setSubmitMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: content?.form.defaults,
  });

  if (!content) {
    return null;
  }

  const onSubmit = async (formValues) => {
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const created = await createYowanAdminReview(formValues);
      setSubmitMessage('保存しました。');
      if (created?.id) {
        navigate(appendYowanContentPreviewQuery('/admin/content/reviews', preservedDomainSearch));
      }
    } catch (error) {
      setSubmitMessage('保存できませんでした。入力内容とログイン状態を確認してください。');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminBlogShell activeNavHref="/admin/content/reviews" routeKey="/admin/content/reviews/new">
      <AdminPageHeader
        title={content.header.title}
        paragraphs={content.header.paragraphs}
        actions={[
          <Link key="back-to-list" to={appendYowanContentPreviewQuery('/admin/content/reviews', preservedDomainSearch)}>
            一覧へ戻る
          </Link>,
        ]}
      />

      <form className="yowan-admin-form c-surface-content" onSubmit={handleSubmit(onSubmit)}>
        <AdminReviewEditorFields content={content} register={register} errors={errors} />

        <label className="c-form__field">
          <span className="c-form__label">{content.form.labels.reviewerUrl}</span>
          <input
            className="c-form__control"
            type="url"
            placeholder="https://example.com/"
            {...register('reviewerUrl', reviewUrlValidationRules(content))}
          />
          {errors?.reviewerUrl ? <em className="yowan-admin-form__error">{errors.reviewerUrl.message}</em> : null}
          {content.form.reviewerUrlHelpText ? (
            <p className="yowan-admin-form__field-note yowan-admin-form__field-note--compact">
              {content.form.reviewerUrlHelpText}
            </p>
          ) : null}
        </label>

        <div className="yowan-admin-form__actions">
          <button type="submit" className="c-form__submit" disabled={isSubmitting}>
            {content.form.submitLabel}
          </button>
        </div>

        {isSubmitting ? (
          <p className="yowan-admin-form__message yowan-admin-form__message--pending">
            <LoadingSpinner inline size="sm" />
            <span>{content.form.pendingMessage}</span>
          </p>
        ) : submitMessage ? (
          <p className="yowan-admin-form__message">{submitMessage}</p>
        ) : null}
      </form>
    </AdminBlogShell>
  );
};

export default AdminReviewsCreatePage;
